const getFilterRelationKeys = (entityName, currentEntityRelations, currentEntityProperties) => currentEntityRelations.filter(({
  entityIdentifier,
  foreignKey
}) => entityIdentifier === entityName && currentEntityProperties[foreignKey]).map(({
  foreignKey
}) => foreignKey);
export default getFilterRelationKeys;
//# sourceMappingURL=get-filter-relation-keys.js.map